import * as stylex from '@stylexjs/stylex';
import { createFileRoute, redirect } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { EmptyState, Heading, Paragraph, View } from '@/libs/serenity-ui';
import { breakpoints } from '@/libs/serenity-ui/constants.stylex';

export const Route = createFileRoute('/_main/')({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      return;
    }

    const canViewAnyModule =
      context.can.reports.view() ||
      context.can.campaignRequests.view() ||
      context.can.apiKeys.view();

    if (!canViewAnyModule) {
      return;
    }

    if (context.can.reports.view()) {
      throw redirect({ to: '/metrics' });
    }

    if (context.can.campaignRequests.view()) {
      throw redirect({ to: '/campaigns' });
    }

    throw redirect({ to: '/api-keys' });
  },
  component: NoModulesRouteComponent,
});

function NoModulesRouteComponent(): ReactElement {
  return (
    <View style={styles.center}>
      <EmptyState style={styles.empty}>
        <Heading>
          No modules enabled
        </Heading>
        <Paragraph>
          Your account is active, but you don&apos;t have access to any features yet. Contact your TrendMD account
          manager to get started.
        </Paragraph>
      </EmptyState>
    </View>
  );
}

const styles = stylex.create({
  center: {
    display: 'flex',
    flex: '1',
    justifyContent: 'center',
    minHeight: 0,
    paddingInline: 24,
    paddingTop: {
      default: null,
      [breakpoints.large]: 200,
    },
    width: '100%',
  },
  empty: {
    maxWidth: 480,
    paddingBlock: 48,
  },
});
